import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";
import * as React from "react";

export const EnvelopeIcon = (props: SvgIconProps) => {
    const { viewBox = "0 0 20 20", ...rest } = props;

    return (
        <SvgIcon data-cy="messageUnreadIcon" viewBox={viewBox} {...rest}>
            <rect fill="none" x="-2" y="-1.99" width="24" height="24" />
            <path
                fill="currentColor"
                d="M16.8,4.74V15.26H3.2V4.74H16.8M18,3.54H2V16.46H18V3.54Z"
            />
            <polygon
                fill="currentColor"
                points="10 12.46 2.37 4.61 3.23 3.77 10 10.74 16.77 3.77 17.63 4.61 10 12.46"
            />
            <rect
                fill="currentColor"
                x="0.97"
                y="12.04"
                width="8.12"
                height="1.2"
                transform="translate(-7.74 7.95) rotate(-48.13)"
            />
            <rect
                fill="currentColor"
                x="14.2"
                y="8.69"
                width="1.2"
                height="8.19"
                transform="translate(-4.75 12.28) rotate(-39.34)"
            />
            <rect fill="none" width="20" height="20" />
        </SvgIcon>
    );
};
